import React, { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import apiService from "../Common/Configurations/APIService";
import config from "../Common/Configurations/APIConfig";
import countriesData from "../Components/Data/Countries.json";
import { HomePageSlider } from "./HomePageSlider";

export default function SaasRegister() {
  const navigate = useNavigate();

  const [basicValues, setBasicValues] = useState({
    companyName: "",
    email: "",
    phoneNumber: "",
    password: "",
    planType: "TRAIL",
    industryId: "00000000-0000-0000-0000-000000000000",
  });

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [apiError, setApiError] = useState(""); // For API error messages

  const handleBasicChange = (e) => {
    const { name, value } = e.target;
    setBasicValues({ ...basicValues, [name]: value });
    if (errors[name]) {
      setErrors({ ...errors, [name]: null });
    }
    // Clear general API error
    if (apiError) {
      setApiError("");
    }
  };

  const validate = () => {
    let temp = {};
    temp.companyName = basicValues.companyName !== "";
    temp.email =
      basicValues.email !== "" && /\S+@\S+\.\S+/.test(basicValues.email);
    temp.phoneNumber = basicValues.phoneNumber !== "";
    temp.password =
      basicValues.password !== "" && basicValues.password.length >= 6;

    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  const togglePasswordVisibility = () => setShowPassword((prev) => !prev);

  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";

  const handleBasicSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setLoading(true);
      setApiError("");

      try {
        const formData = new FormData();
        formData.append("CompanyName", basicValues.companyName);
        formData.append("Email", basicValues.email);
        formData.append("PhoneNumber", basicValues.phoneNumber);
        formData.append("Password", basicValues.password);
        formData.append("PlanType", "TRAIL");
        formData.append("IsRenewal", false);
        formData.append("IndustryId", basicValues.industryId);
        formData.append("parentCompanyId", config.DEFAULTCOMPANYID);

        console.log("Sending registration request...", basicValues);

        const response = await apiService.create(config.SAASREGISTER, formData);

        console.log("Registration response:", response);

        if (response && response.success && response.companyId) {
          // Navigate to tax information screen with company data
          navigate("/tax-information", {
            state: {
              companyId: response.companyId,
              userEmail: basicValues.email,
            },
          });
        } else {
          if (response && response.message) {
            setApiError(response.message);
          } else {
            setApiError("Registration failed. Please try again.");
          }
        }
      } catch (error) {
        console.error("Registration error:", error);
        if (error.response && error.response.data) {
          const errorData = error.response.data;
          setApiError(
            errorData.message || "Registration failed. Please try again."
          );
        } else if (error.message) {
          setApiError(error.message);
        } else {
          setApiError("Registration failed. Please try again.");
        }
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="auth-page-wrapper py-5 d-flex justify-content-center align-items-center min-vh-100">
      <div className="bg-overlay" style={{ backgroundColor: "#F2F44E" }}></div>
      <div className="auth-page-content overflow-hidden mt-lg-4">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="card overflow-hidden">
                <div className="row g-0">
                  <div className="col-lg-6">
                    <div className="card overflow-hidden rounded-4 loginbox shadow">
                      <div className="p-lg-5 p-4">
                        <h3 className="text-center">REGISTRATION</h3>
                        <form
                          onSubmit={handleBasicSubmit}
                          autoComplete="off"
                          noValidate
                        >
                          <div className="mb-3">
                            <label className="form-label">Company Name*</label>
                            <input
                              type="text"
                              className={
                                "form-control" + applyErrorClass("companyName")
                              }
                              name="companyName"
                              value={basicValues.companyName}
                              onChange={handleBasicChange}
                              placeholder="Enter Company Name"
                              required
                            />
                            {errors.companyName === false && (
                              <div className="validationerror">
                                Please enter company name
                              </div>
                            )}
                          </div>

                          <div className="mb-3">
                            <label className="form-label">Email*</label>
                            <input
                              type="text"
                              className={
                                "form-control" + applyErrorClass("email")
                              }
                              name="email"
                              value={basicValues.email}
                              onChange={handleBasicChange}
                              placeholder="Enter Email"
                              required
                            />
                            {errors.email === false && (
                              <div className="validationerror">
                                Please enter valid email
                              </div>
                            )}
                          </div>

                          <div className="mb-3">
                            <label className="form-label">Phone Number*</label>
                            <input
                              type="text"
                              className={
                                "form-control" + applyErrorClass("phoneNumber")
                              }
                              name="phoneNumber"
                              value={basicValues.phoneNumber}
                              onChange={handleBasicChange}
                              placeholder="Enter Phone Number"
                              maxLength={15}
                              required
                            />
                            {errors.phoneNumber === false && (
                              <div className="validationerror">
                                Please enter phone number
                              </div>
                            )}
                          </div>

                          <div className="mb-3">
                            <label className="form-label">Password*</label>
                            <div className="position-relative auth-pass-inputgroup mb-1">
                              <input
                                type={showPassword ? "text" : "password"}
                                className={
                                  "form-control" + applyErrorClass("password")
                                }
                                name="password"
                                value={basicValues.password}
                                onChange={handleBasicChange}
                                placeholder="Enter Password"
                                required
                              />
                              <span
                                className="position-absolute"
                                style={{
                                  right: "10px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  cursor: "pointer",
                                }}
                                onClick={togglePasswordVisibility}
                              >
                                {showPassword ? (
                                  <i className="ri-eye-line"></i>
                                ) : (
                                  <i className="ri-eye-off-line"></i>
                                )}
                              </span>
                            </div>
                            {errors.password === false && (
                              <div className="validationerror">
                                Password must be at least 6 characters
                              </div>
                            )}
                          </div>

                          {/* Show general API errors */}
                          {apiError && (
                            <div className="alert alert-danger">{apiError}</div>
                          )}

                          <div className="mt-4 d-flex justify-content-end">
                            {!loading ? (
                              <button
                                type="submit"
                                className="btn btn-success w-100 me-2"
                              >
                                Register Now
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="btn btn-primary w-100 me-2"
                                disabled
                              >
                                Registering...
                              </button>
                            )}
                            <Link to="/" className="btn btn-danger me-2 w-100">
                              Back
                            </Link>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <HomePageSlider />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
